import { render, staticRenderFns } from "./SmallLoadingLogo.vue?vue&type=template&id=4966cea2&scoped=true&"
import script from "./SmallLoadingLogo.vue?vue&type=script&lang=js&"
export * from "./SmallLoadingLogo.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoadingLogo.vue?vue&type=style&index=0&id=4966cea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966cea2",
  null
  
)

export default component.exports